import { subscribe, unsubscribe } from '@wh/message-bus';
import { OB_SESSION_STATE_CHANGED_EVENT, REQUEST_GOT_LOGIN_STATE_EVENT } from '../../topics';
import { handleOBSessionStateChanged, handleRequestGotLoginState } from './handlers';

export const getCookieDomain = (url) => {
  const domainRegEx = /\w*(\.williamhill(?:-)?(\w*)?\.([\w]{2,}))/g;
  const [, domain] = domainRegEx.exec(url) || new Array(2);
  return domain;
};

export default (serviceUrl, config, jurisdiction) => {
  const domain = getCookieDomain(serviceUrl);

  const obSessionSubscription = subscribe({
    topic: OB_SESSION_STATE_CHANGED_EVENT,
    callback: handleOBSessionStateChanged({ jurisdiction, domain, config }),
  });

  const requestGotLoginStateSubscription = subscribe({
    topic: REQUEST_GOT_LOGIN_STATE_EVENT,
    callback: handleRequestGotLoginState,
  });

  return () => {
    unsubscribe(obSessionSubscription);
    unsubscribe(requestGotLoginStateSubscription);
  };
};
